import { render, staticRenderFns } from "./ecRatio.vue?vue&type=template&id=4a625620&scoped=true"
import script from "./ecRatio.vue?vue&type=script&lang=js"
export * from "./ecRatio.vue?vue&type=script&lang=js"
import style0 from "./ecRatio.vue?vue&type=style&index=0&id=4a625620&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a625620",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\project\\yl\\yl-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4a625620')) {
      api.createRecord('4a625620', component.options)
    } else {
      api.reload('4a625620', component.options)
    }
    module.hot.accept("./ecRatio.vue?vue&type=template&id=4a625620&scoped=true", function () {
      api.rerender('4a625620', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/home-page/compontents/ecRatio.vue"
export default component.exports